import { TransformDate } from '../../../shared/decorators/transform-date.decorator';

/**
 * Renew filebox record DTO
 */
export class RenewFileboxRecordDto {
	synchronizationToken!: string;
	@TransformDate()
	leasedUntil?: Date;
}
